import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Treeselect from '@riophae/vue-treeselect';
import Paginate from "vuejs-paginate";
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import PageTracker from '../../../common/PageTrackerHelper'

export default {
  name: 'VerifyShipmentBrandBox',
  components: {
      VueElementLoading,
      Treeselect,
      Paginate,
  },
  mixins:[PageTracker],
  data: function() {
      return {
        scan : 'scanVerify',
        verify : 'VerifyOFD',
        verifySearch : 'VerifyDoneOFDPending',
        shippingID : '',
        disputeReason : '',
        disputeReasonList : [],
        comments :'',
        hubList : [],
        hubID : '',
        localusermailid :'',
        hubdetails : '',
        searchResult : [],
        userDataKey : ''
      }
  },
  created: function() {
  this.getHubList();
  this.getdisputeReason();
  },
  async mounted(){
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
   var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
   var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
   var plaintext = bytes.toString(CryptoJS.enc.Utf8);
   var userdetail = JSON.parse(plaintext);
   this.localuserid = userdetail.userid;
   this.localusermailid = userdetail.email;
   this.rolename = userdetail.userrole[0]['rolename'];
   this.hubdetails = userdetail.hubdetails[0];
  //  let TrackerInfo = {
  //      projectname:"Last Mile",
  //      type:"Web",
  //      userid:this.localuserid,
  //      username:this.localusermailid,

  //      meta: {
  //          "event":""
  //      }
  //  }
  //  let result  = this.PageTracker(TrackerInfo);
  },
  methods : {
    getHubList(){

       axios.get(apiUrl.api_url + 'shipmentMisrout/gethublist', {})
        .then((response) => {
            if(response.data.code===200){
                this.hubList = response.data.data;
                this.hubID = this.hubdetails;
            }
            else {
                this.hubList = [];
            }
        })
        .catch((httpException) => {
            this.$alertify.error("hub data not found");
            console.error('exception is:::::::::', httpException)
        })

    },
    getdisputeReason(){
      axios.post(apiUrl.api_url + 'shipmentMisrout/reasondetailsbytype', {
        "ReasonType" : "Dispute"
      })
        .then((response) => {
            if(response.data.code===200){
                this.disputeReasonList = response.data.data;
            }
            else {
                this.disputeReasonList=[];
            }
        })
        .catch((httpException) => {
            this.$alertify.error("No Dispute Reason Found");
            console.error('exception is:::::::::', httpException)
        })
    },
    getDisputeBrandBox(){

      let input = {
        "ShippingID":this.shippingID,
        "ProcessLocation": this.hubdetails,
        "VerifyReason":"Verified",
        "VerifyType":this.verify,
        "DisputeStatusCode":this.disputeReason,
        "Comments":this.comments,
        "LastModifiedBy":this.localusermailid
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'expose/VerifyShipmentBrandBoxAdd',
          'data': input,
          header:{
            'content-type': 'application/json'
          }
        }).then(result => {
          if(result.data.code === 200){
          this.$alertify.success(result.data.message);
        }else {
          this.$alertify.error(result.data.message);
        }
    })
    .catch((httpException) => {
        this.$alertify.success("Something went wrong!!");
        console.error('exception is:::::::::', httpException)
    });

    },
    search(){

            let input = {
              "HubId" : this.hubdetails,
              "VerifyStatus" : this.verifySearch,
            }
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'expose/VerifyShipmentBrandBox_VerificationReport',
                'data': input,
                header:{
                  'content-type': 'application/json'
                }
              }).then(result => {
                console.log(result.data);
                if(result.data.code === 200){
                  this.searchResult = result.data.data;
                }else {
                  this.$alertify.error(result.data.message);
                }
          })
          .catch((httpException) => {
              this.$alertify.success("Something went wrong!!");
              console.error('exception is:::::::::', httpException)
          });
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.getDisputeBrandBox();
        }
        else {
          this.$alertify.error("Please fill in the required fields");
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    clear(){
      this.scan = 'scanVerify';
      this.verify = 'verifyOFD';
      this.verifySearch = 'VerifyDoneOFDPending',
      this.shippingID = '';
      this.disputeReason = '';
      this.searchResult = [];

      this.$validator.reset();
      this.errors.clear();
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/VerifyShipmentBrandBox/VerifyShipmentBrandBox.component.js